"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHints = exports.createModemIntermediateExecuting = exports.createModemIntermediateResolving = exports.createModemFinalDidNotRun = exports.createModemFinalFailed = exports.createModemFinalAvailable = exports.ModemNotRunReason = exports.ModemFinalKind = exports.createPingFinal = exports.createPingIntermediate = exports.createUploadFinal = exports.createUploadIntermediate = exports.createDownloadFinal = exports.createDownloadIntermediate = exports.createBenchmarkFinalDidNotRun = exports.createBenchmarkFinalAvailable = exports.createBenchmarkIntermediate = exports.createPrepareResult = exports.NQValueKind = void 0;
const immer_1 = require("immer");
var NQValueKind;
(function (NQValueKind) {
    NQValueKind["PrepareResult"] = "PrepareResult";
    NQValueKind["BenchmarkIntermediate"] = "BenchmarkIntermediate";
    NQValueKind["BenchmarkFinalAvailable"] = "BenchmarkFinalAvailable";
    NQValueKind["BenchmarkFinalDidNotRun"] = "BenchmarkFinalDidNotRun";
    NQValueKind["DownloadIntermediate"] = "DownloadIntermediate";
    NQValueKind["DownloadFinal"] = "DownloadFinal";
    NQValueKind["UploadIntermediate"] = "UploadIntermediate";
    NQValueKind["UploadFinal"] = "UploadFinal";
    NQValueKind["PingIntermediate"] = "PingIntermediate";
    NQValueKind["PingFinal"] = "PingFinal";
    NQValueKind["Complete"] = "Complete";
    NQValueKind["ModemIntermediateResolving"] = "ModemIntermediateResolving";
    NQValueKind["ModemIntermediateExecuting"] = "ModemIntermediateExecuting";
    NQValueKind["ModemFinal"] = "ModemFinal";
    NQValueKind["Hints"] = "Hints";
    NQValueKind["Warning"] = "Warning";
})(NQValueKind = exports.NQValueKind || (exports.NQValueKind = {}));
;
const createPrepareResult = (config, init, isIPv6) => {
    return (0, immer_1.freeze)({
        kind: NQValueKind.PrepareResult,
        config,
        init,
        isIPv6
    });
};
exports.createPrepareResult = createPrepareResult;
const createBenchmarkIntermediate = (result1) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.BenchmarkIntermediate, result1 });
};
exports.createBenchmarkIntermediate = createBenchmarkIntermediate;
const createBenchmarkFinalAvailable = (result1, result2) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.BenchmarkFinalAvailable, result1, result2 });
};
exports.createBenchmarkFinalAvailable = createBenchmarkFinalAvailable;
const createBenchmarkFinalDidNotRun = () => {
    return (0, immer_1.freeze)({ kind: NQValueKind.BenchmarkFinalDidNotRun });
};
exports.createBenchmarkFinalDidNotRun = createBenchmarkFinalDidNotRun;
const createDownloadIntermediate = (speed) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.DownloadIntermediate, speed });
};
exports.createDownloadIntermediate = createDownloadIntermediate;
const createDownloadFinal = (speed, jitter) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.DownloadFinal, speed, jitter });
};
exports.createDownloadFinal = createDownloadFinal;
const createUploadIntermediate = (speed) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.UploadIntermediate, speed });
};
exports.createUploadIntermediate = createUploadIntermediate;
const createUploadFinal = (speed, jitter) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.UploadFinal, speed, jitter });
};
exports.createUploadFinal = createUploadFinal;
const createPingIntermediate = (pingTime) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.PingIntermediate, pingTime });
};
exports.createPingIntermediate = createPingIntermediate;
const createPingFinal = (pingTime, jitter) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.PingFinal, pingTime, jitter });
};
exports.createPingFinal = createPingFinal;
;
;
var ModemFinalKind;
(function (ModemFinalKind) {
    ModemFinalKind["ModemFinalAvailable"] = "ModemFinalAvailable";
    ModemFinalKind["ModemFinalDidNotRun"] = "ModemFinalDidNotRun";
    ModemFinalKind["ModemFinalFailed"] = "ModemFinalFailed";
})(ModemFinalKind = exports.ModemFinalKind || (exports.ModemFinalKind = {}));
;
var ModemNotRunReason;
(function (ModemNotRunReason) {
    // Modem test did not run because the download speed was matching the contract, thus there were no need for a modem test
    ModemNotRunReason["NotNeeded"] = "NotNeeded";
    // Modem test did not run because the CMTS the customer is connected to does not support a modem test
    ModemNotRunReason["NotAvailable"] = "NotAvailable";
    // Modem test did not run because the user is no customer
    ModemNotRunReason["NotACustomer"] = "NotACustomer";
})(ModemNotRunReason = exports.ModemNotRunReason || (exports.ModemNotRunReason = {}));
const defaultSpeedtestState = {
    downloadClient: true,
    uploadClient: true,
    downloadUdp: null,
};
const createModemFinalAvailable = (speed, speedtestState = defaultSpeedtestState, parallelTraffic = null, connectionType = null) => {
    return (0, immer_1.freeze)({
        kind: NQValueKind.ModemFinal,
        parallelTraffic,
        connectionType,
        modemFinal: {
            kind: ModemFinalKind.ModemFinalAvailable,
            speed,
        },
        speedtestState,
    });
};
exports.createModemFinalAvailable = createModemFinalAvailable;
const createModemFinalFailed = (message, speedtestState = defaultSpeedtestState, parallelTraffic = null, connectionType = null) => {
    return (0, immer_1.freeze)({
        kind: NQValueKind.ModemFinal,
        parallelTraffic,
        connectionType,
        modemFinal: {
            kind: ModemFinalKind.ModemFinalFailed,
            message,
        },
        speedtestState: Object.assign(Object.assign({}, speedtestState), { downloadUdp: null })
    });
};
exports.createModemFinalFailed = createModemFinalFailed;
const createModemFinalDidNotRun = (reason, speedtestState = defaultSpeedtestState, parallelTraffic = null, connectionType = null) => {
    return (0, immer_1.freeze)({
        kind: NQValueKind.ModemFinal,
        parallelTraffic,
        connectionType,
        modemFinal: {
            kind: ModemFinalKind.ModemFinalDidNotRun,
            reason,
        },
        speedtestState: Object.assign(Object.assign({}, speedtestState), { downloadUdp: null })
    });
};
exports.createModemFinalDidNotRun = createModemFinalDidNotRun;
const createModemIntermediateResolving = () => {
    return (0, immer_1.freeze)({ kind: NQValueKind.ModemIntermediateResolving });
};
exports.createModemIntermediateResolving = createModemIntermediateResolving;
const createModemIntermediateExecuting = () => {
    return (0, immer_1.freeze)({ kind: NQValueKind.ModemIntermediateExecuting });
};
exports.createModemIntermediateExecuting = createModemIntermediateExecuting;
const createHints = (hints) => {
    return (0, immer_1.freeze)({ kind: NQValueKind.Hints, hints });
};
exports.createHints = createHints;
//# sourceMappingURL=NQValue.js.map